import React from 'react'
import RequestsBeneficios from '../../componentsGeneral/componentsSuperUser/studentProfile/requestsBeneficios/RequestsBeneficios'

const RequestBenefis = () => {
  return (
    <div>
        <RequestsBeneficios/>
    </div>
  )
}

export default RequestBenefis